import { FunctionComponent } from "react";
import TopNav from "../../components/navigation/TopNav";
import Contact from "../../components/website/Contact";
import Footer from "../../components/website/Footer";
import MobileNav from "../../components/navigation/MobileNav";


const ContactUs: FunctionComponent = () => {
    return (
        <div className="max-w-[1440px] mx-auto w-full">
            <TopNav />
            <MobileNav />
            <Contact />
            <Footer />
        </div>
    )
};

export default ContactUs;